export class GetLocationAction {
  static readonly type = '[Location] Get item';
  constructor(public id: string) {}
}
